import { Img } from "components";
// import TextArea from "../components/TextArea";
import { /* useRef, */ useState } from "react";
import { useNavigate } from "react-router-dom";
import Wrapper from "../components/Wrapper";
import Modal from 'react-modal';

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/schl-mgmnt.mp4" }
]

const LIST_OF_SCHOOL_MANAGMENT_POINTS = [
    {
        "title": "📞 Auto Connect",
        "points": [
            "AI IVR calls in regional languages — plus SMS & WhatsApp announcements."
        ]
    },
    {
        "title": "📝 Homework Tracking",
        "points": [
            "Parent updates via WhatsApp/App, teachers see in one dashboard",
        ]
    },
    {
        "title": "✅ Smart Attendance",
        "points": [
            "QR auto-marking & alerts — 200+ teacher hours saved/year.",
        ]
    },
    {
        "title": "📅 Exam Management",
        "points": [
            "Automated scheduling & reminders",
            "Digital result publishing"
        ]
    },
    {
        "title": "📄 Exam Results",
        "points": [
            "Auto-publish exam results — parents get instant alerts."
        ]
    },
    {
        "title": "📹 Record & Report",
        "points": [
            "Screen record with voice — send issues directly to us."
        ]
    },
    {
        "title": "🗂️ To-Do & Assign Task",
        "points": [
            "Assign tasks, track to-dos — less chaos, more clarity."
        ]
    },
    {
        "title": "📣 Social Hub",
        "points": [
            "Auto-schedule school posts/events — no manual work needed"
        ]
    },
    {
        "title": "🎉 PTM Organiser",
        "points": [
            "Easy hassle free scheduling and managing",
            "Auto WhatsApp reminders"
        ]
    },
    {
        "title": "💰 Fee Automation",
        "points": [
            "Payment reminders & tracking",
            "UPI/online payment support",
            "65% faster collections"
        ]
    }
];

const customStylesAskModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '40rem',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        padding: '1.3em',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};

const SchoolManagment = () => {
    const navigate = useNavigate();
    // const videoRef = useRef(null);
    const [videDemoModal, setVideDemoModal] = useState<any>("");
    const [position, setPosition] = useState(0);

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    return (
        <Wrapper
            title={<>Your Complete School Management <br /> Software System, Now Free</>}
            titleSize="text-[4.5vh]"
            videoLinks={videoLinks}
            body={<>
                <Modal
                    isOpen={!!videDemoModal}
                    contentLabel="Example Modal"
                    style={customStylesAskModal}
                >
                    <div className="flex justify-between mb-4">
                        <h1 className="font-bold text-xl">How it works</h1>
                        <button onClick={() => setVideDemoModal(false)}>
                            <Img src="/images/Close.svg" alt="close" className="h-8" />
                        </button>
                    </div>
                    <video
                       src={videDemoModal}
                       controls
                        className="bg-[white] w-full"
                    />
                </Modal>
                <div className="grid grid-cols-5 gap-4 w-full">
                    <div className="col-span-5 text-center">
                        <p className="text-[2.2vh]">A 100% free school management platform that handles everything</p>
                    </div>
                    <div className="col-span-5 text-center">
                        <h2 className="text-smd_blue-dark font-manropeB text-[3vh]">Features That Save Time & Money for Schools</h2>
                    </div>
                    {LIST_OF_SCHOOL_MANAGMENT_POINTS?.map((item, index) => <div key={"askjdbasjdasd" + index} className="bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl p-[2vh] text-[#081B34] space-y-2">
                        <h2 className="font-manropeSB text-[2.6vh]">{item?.title}</h2>
                        <div className="text-[2.1vh] space-y-2">
                            {item?.points?.map((para, innerIndex) => <p key={"ansldkasdhaskjdasd" + innerIndex}>{para}</p>)}
                            {[1,2]?.includes(index) && <button type="button" onClick={() => setVideDemoModal(() => index === 1 ? "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/smart-hw.mp4" : "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/DemoEvents/smart-qr.mp4")} className="text-smd_blue-normal font-manropeSB">How It Works</button>}
                        </div>
                    </div>)}
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-7 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-3xl font-[1000] leading-[120%] tracking-[-1%]">Your Complete School Management <br /> Software System, Now Free</h1>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                     <video
        //                         // ref={step3Ref} 
        //                         // ref={videoRef}
        //                         src={videoLinks?.[position]?.url || videoLinks?.at(-1)?.url}
        //                         autoPlay
        //                         // muted={isMuted}
        //                         onEnded={() => {
        //                             if (+position < videoLinks?.length - 1) {
        //                                 setPosition(position => +position + 1)
        //                             } else {
        //                                 setPosition(undefined)
        //                             }
        //                             // You can also update state here if needed
        //                         }}
        //                         playsInline
        //                         // onLoadStart={() => setIsLoading(isLoading => true)}
        //                         // onLoadedData={() => setIsLoading(isLoading => false)}
        //                         // onError={() => setIsLoading(isLoading => false)}
        //                         className="w-[18vh] h-[18vh] object-top object-cover bg-[white] rounded-lg"
        //                     />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="grid grid-cols-5 gap-3 w-full">
        //             <div className="col-span-5 text-center">

        //                 <p className="text-sm">A 100% free school management platform that handles everything</p>
        //             </div>
        //             <div className="col-span-5 text-center">
        //                 <h2 className="text-smd_blue-dark font-manropeSB text-2xl">Features That Save Time & Money for Schools</h2>
        //             </div>
        //             {LIST_OF_SCHOOL_MANAGMENT_POINTS?.map((item,index) =>  <div key={"askjdbasjdasd"+index} className="bg-smd_white-normal rounded-2xl p-4 text-[#081B34] space-y-2">
        //                 <h2 className="font-manropeSB text-base">{item?.title}</h2>
        //                 <div className="text-sm space-y-2">
        //                     {item?.points?.map((para, innerIndex) => <p key={"ansldkasdhaskjdasd"+innerIndex}>{para}</p>)}
        //                 </div>
        //             </div>)}
        //         </div>

        //         <Stepper />
        //     </div>
        // </div>
    );
}

export default SchoolManagment;